<template lang="pug">
  .container
    .header
      img.banner(src="../../../public/images/shaanxi/confirmjanvideoflow-header.jpg")
    .mobile-form
      img(src="../../../public/images/shaanxi/janvideoflow-info.jpg")
      el-form.form-content
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入陕西移动手机号")
        el-form-item
          el-row.verify-controls
            el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-button(:disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后可重试
        el-form-item.submit-btn
          el-button(type="warning", @click="showConfirm") 确定办理
    //- .img-desc
    //-   img(src="../../../public/images/shaanxi/confirmjanvideoflow-price.png")
    .notice
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible",
      :before-close="handleClose"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info {{selectedPackage.confirmInfo}}
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
    .share-dialog(v-if="shareNoticeVisiable", @click="shareNoticeVisiable = false")
      img(src="../../assets/images/shaanxi/share-dialog.png")
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      dialogVisible: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'TUIA',
      form: {
        carrierId: 1,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '资费说明：本活动仅限陕西移动用户参加，需话费支付30元，包含30GB国内通用流量，2个热门视频APP周卡会员权益（周会员权益领取成功后有效期7天），流量包及会员权益领取有效期10天。',
        '生效时间：本包30元30GB金牛贺岁包（权益版）订购后一次性收取费用，办理后立即生效，到期自动失效，生效后不可退订，可叠加办理。',
        '流量包使用优先级同传统假日流量包，高于套内流量，低于小时包、日包。流量不可结转、不可共享，订购关系到期自动失效。',
        '热门视频APP包含爱奇艺、优酷、腾讯、PP视频、芒果TV、搜狐会员权益，客户需在流量包生效后有效期内自行点击链接领取，过期领取将自动失效。权益领取链接：https://dx.10086.cn/shipin。',
        '赠送咪咕钻石会员权益将由系统自动关联开通平台业务，无需领取，有效期至办理当月月底。',
        '扣费方式：该产品需要扣除话费办理，办理之前话费余额需要大于办理套餐的费用；该业务办理成功后不能抵扣之前超出的流量。',
        '温馨提示：办理本业务时，请确认手机号码和短信验证码输入正确。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA20210122001',
          confirmInfo: '限时价30元二个视频会员权益+30G国内流量'
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
  },
  methods: {
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            if (this.form.userId) {
              this.$router.push({
                name: 'videoflowbagSuccess'
              })
            } else {
              this.$router.push({
                name: 'videoflowbagCommonSuccess'
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: #4725b7;
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  background-color: rgb(105, 75, 203);
  margin: 0 1rem;
  padding: .8rem;
  border-radius: 12px;
  img{
    width: 100%;
    border-radius: 12px;
  }
  .form-content{
    width: 90%;
    margin: 1rem auto;
    input{
      border-radius: 24px;
    }
  }
  .submit-btn{
    // z-index: 9;
    // position: fixed;
    // bottom: 0;
    margin: 0 auto;
    margin-top: 1rem;
    height: 2.9rem;
    button{
      width: 100%;
      border-radius: 0;
      font-size: 1.3rem;
      font-weight: bold;
      border-radius: 36px;
      background: linear-gradient(rgb(224, 101, 234), rgb(159, 41, 224));
      border: 0;
    }
  }
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  background: url('../../../public/images/shaanxi/janvideoflow-protocol.png') no-repeat;
  background-size: 100%;
  border-radius: .4rem;
  padding-top: 4rem;
  ul{
    width: 80%;
    margin: 0 auto;
    background-color: #fff;
    font-size: .8rem;
    color: #333;
    border-radius: 12px;
    padding: 1rem;
    li{
      clear: both;
      overflow: hidden;
      
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
.verify-controls{
  .el-input{
    width: 60%;
    input{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 40px;
      line-height: 40px;
      vertical-align: top;
    }
  }
  button{
    width: 40%;
    padding:0;
    height: 40px;
    line-height: 40px;
    border: 0;
    border-radius: 0;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    vertical-align: top;
  }
}
</style>